module.exports = __webpack_public_path__ + "img/showcase-actionplans-en-ca.bba3102e.jpg";